import { render } from "@/components/pages/individualActiveTest/activeTestControlPanel/requirementSP4/RequirementSP4.html?vue&type=template&id=6b42f9cc&external"
import script from "@/components/pages/individualActiveTest/activeTestControlPanel/requirementSP4/RequirementSP4.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualActiveTest/activeTestControlPanel/requirementSP4/RequirementSP4.js?vue&type=script&lang=js&external"

import "@/components/pages/individualActiveTest/activeTestControlPanel/requirementSP4/RequirementSP4.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__